import React from 'react';
import PropTypes from 'prop-types';
import * as utilFunctions from './utilFunctions';
import {crossfilter} from 'dc';
import ObjGeneral from '../../../../../containers/function';

export function hex2rgba(hexa,opacity=null){
  var r = parseInt(hexa.slice(1,3), 16);
  var g = parseInt(hexa.slice(3,5), 16);
  var b = parseInt(hexa.slice(5,7), 16);
  var a = opacity;
  if(a == null) {
    a = parseInt(hexa.slice(7,9), 16)/255;
  }
  return 'rgba('+r+', '+g+', '+b+', '+a+')';
}

export function colorRangePropType() {
    return PropTypes.shape({ // example {"color":"red","colorWrapper":"<div>%v</div>","range":[{"value":60,"operator":">="}]}
          color: PropTypes.string.isRequired,
          colorWrapper: PropTypes.string,
          range: PropTypes.arrayOf(utilFunctions.rangePropType()).isRequired
        });
}

export function getColorProps(colorRanges, value, rangeParser) {
  var color = "inherit";
  var colorWrapper = "%v";
  for(var i=0;i<colorRanges.length;i++) {
    var colorRange = colorRanges[i];
    if(isInRange(colorRange.range,value,[],rangeParser)) {
      color = colorRange.color;
      if("colorWrapper" in colorRange) {
        colorWrapper = colorRange.colorWrapper;
      }
    }
  }

  return {color: color, colorWrapper: colorWrapper};
}


export function colorWrapValue(colorProps, value) {
    return '<span style="color:' + colorProps.color + ';">' + utilFunctions.wrapValue(colorProps.colorWrapper,value) + '</span>';
}

export function isInRange(range, value, formatFunctions, categoriesParser) {
  var operation = true;
  var isInRange = true;
  var tempValue = runFormatFunctions(formatFunctions,value);  
  
  for(var i=0;i<range.length;i++) {
    var rangeValue = runFormatFunctions(categoriesParser,range[i].value);

    switch (range[i].operator) {
      case '>':   operation = tempValue > rangeValue; break;
      case '<':   operation = tempValue < rangeValue; break;
      case '>=':  operation = tempValue >= rangeValue; break;
      case '<=':  operation = tempValue <= rangeValue; break;
      case '<=':  operation = tempValue <= rangeValue; break;
      case '==':  operation = tempValue == rangeValue; break;
      case '!=':  operation = tempValue != rangeValue; break;
      case 'like':  
        operation = ((rangeValue !== null
          && typeof tempValue == 'string' 
          && tempValue.trim().toLowerCase().indexOf(rangeValue.trim().toLowerCase()) != -1) ? true : false);
        break;
      
    }

    if(rangeValue == "ALL") {
      operation = true;
    }

    switch (range[i].lastLogicOperator) {
      case 'AND': isInRange = isInRange && operation; break;
      case 'OR': isInRange = isInRange || operation; break;
      default: isInRange = isInRange && operation; break;
    }
  }

  return isInRange;
}

export function setConfigParams(configParams, defaultConfigParams) {
  var setedConfigParams = ObjGeneral.cloneObject(defaultConfigParams);

  if(typeof configParams !== "object" || configParams instanceof Array || configParams == null) {
    return configParams;
  }

  for (var key in configParams) {
    setedConfigParams[key] = setConfigParams(configParams[key], setedConfigParams[key]);
  }

  return setedConfigParams;
}

function runFormatFunction(functionArray,object) {
    switch (functionArray[0]) {
      case 'getDay':   return object.getDay();
      case 'getFullYear':   return object.getFullYear();
      case 'getHours':   return object.getHours();
      case 'getMinutes':   return object.getMinutes();
      case 'getMonth':   return object.getMonth();
      case 'getAbsoluteDateYear':   return new Date(object.getFullYear(),0,1,0,0,0,0);
      case 'getAbsoluteDateMonth':   return new Date(object.getFullYear(),object.getMonth(),1,0,0,0,0);
      case 'parseDate':
        var parseDate = d3.time.format.utc(functionArray[1]).parse; 
        var dateReturned = parseDate(object);
        return dateReturned;
      case 'parseDateUTC':
        var parseDate = d3.time.format.utc(functionArray[1]).parse; 
        var dateReturned = parseDate(object);
        return dateReturned.getTime(); 
      case 'parseDateStringFormat':
        var objectAux = object;
        var formatIn = functionArray[1][1];
        if(formatIn=='%Y-%m') {
          objectAux+="-01";
          formatIn+="-%d";
        }
        var parser = d3.time.format.utc(formatIn).parse;
        var date = parser(objectAux);
        date.setTime(date.getTime() + date.getTimezoneOffset() * 60000);
        var formatter = d3.time.format(functionArray[1][0]);
        return formatter(date);
      case 'newDate' :  return new Date(object);
      case 'round' :  return Math.round(object);
      default: return object;
    }
}

export function runFormatFunctions(formatFunctions,object) {
  var finalObject = object;

  for(var i=0;i<formatFunctions.length;i++) {
    finalObject = runFormatFunction(formatFunctions[i],finalObject)    
  }

  return finalObject;
}

export function setFilterValues(dim, filterValues)
{
  var filters = ObjGeneral.cloneObject(filterValues.filters);
  for(var i=0;i<filters.length;i++) {
    if("fixedValues" in filterValues && i<filterValues.fixedValues.length) {
      filters[i].value = filterValues.fixedValues[i];
    }
    if("diff" in filters[i]) {
      filters[i].value += filters[i].diff;
    }
  }
  dim.filterAll();
  dim.filterFunction(function(d) { return isInRange(filters,d,[],filterValues.filterParser); });
}

export function checkFilters(filters,row) {
  var result = true;

  for(var i=0;i<filters.length;i++) {
    result = result && isInRange(filters[i].filters, row[filters[i].dimension], filters[i].formatFunction, filters[i].filterParser);
  }

  return result;
}

//grupos vacios en discreto no se eliminan (categoria debe estar), en continuo si, y si el valor es null el grupo no esta vacio, ver como se trata.
function checkNullAdd(p,v,metricParams) {
  ++p.withNullCount;
  p.empty = false;
  if(v[metricParams.metric] == null) {
    setNullValue(p,v,metricParams);
    return true;
  }
  else if(p.count == 0) {
    p.value = 0;
  }
  return false;  
}

function checkNullRemove(p,v,metricParams) {
  --p.withNullCount;
  if(p.withNullCount == 0) {
    p.empty = true;
  }
  if(v[metricParams.metric] == null) {
    return true;
  }
  return false; 
}

function setNullValue(p,v,metricParams) {
  if(p.count == 0 && p.withNullCount>0) {
    p.value = null;
  }
  else if(p.count == 0 && p.withNullCount==0){
    p.value = 0;
  }  
}

function fixFloatingPointProblem(p) {
  if(p.value != null && isNaN(p.value)==false) {
    p.value = Math.round(p.value*1000)/1000;
    if(p.value==0) {
      p.value = 0;
    }
  }
}

//ojo que si cambia puede haber errores
export function crossfilterReduceAddFirstValue(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullAdd(p,v,metricParams)) {
      p.value = runFormatFunctions(metricParams.formatFunction,v[metricParams.metric]);  
      ++p.count;
    }
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceRemoveFirstValue(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullRemove(p,v,metricParams)) {
      --p.count;
      if(p.count == 0) {
        p.value = "";        
      } 
    }
    setNullValue(p,v,metricParams);
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceInitFirstValue() {
  return {count:0, withNullCount: 0, value:"", empty: true};
}

export function crossfilterReduceAddSum(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullAdd(p,v,metricParams)) {
      ++p.count; 
      p.value += runFormatFunctions(metricParams.formatFunction,v[metricParams.metric]); 
    }
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceRemoveSum(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullRemove(p,v,metricParams)) {
      --p.count;
      p.value -= runFormatFunctions(metricParams.formatFunction,v[metricParams.metric]); 
    }
    setNullValue(p,v,metricParams);
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceInitSum() {
  return {count:0, withNullCount: 0, value:0, empty: true};
}

export function crossfilterReduceAddCount(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullAdd(p,v,metricParams)) {
      ++p.count; 
      ++p.value;      
    }
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceRemoveCount(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullRemove(p,v,metricParams)) {
      --p.count;
      --p.value;
    }
    setNullValue(p,v,metricParams);
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceInitCount() {
  return {count:0, withNullCount: 0, value:0, empty: true};
}

export function crossfilterReduceAddAvg(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullAdd(p,v,metricParams)) {
      ++p.count;
      p.sum += runFormatFunctions(metricParams.formatFunction,v[metricParams.metric]);
      p.value = p.sum/p.count;
    }
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceRemoveAvg(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullRemove(p,v,metricParams)) {
      --p.count;
      p.sum -= runFormatFunctions(metricParams.formatFunction,v[metricParams.metric]);
      if(p.count == 0) {
        p.value = 0;
      }
      else {
        p.value = p.sum/p.count;
      }
    }
    setNullValue(p,v,metricParams);
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceInitAvg() {
  return {count:0, withNullCount: 0, sum:0, value:0, empty: true};
}

export function crossfilterReduceAddPctCountGroup(metricParams) {
  return function(p,v) {
    if(!checkNullAdd(p,v,metricParams)) {
      if(checkFilters(metricParams.filter,v)) {
        p.sum += 1;      
      }
      ++p.count;
      p.value = p.sum/p.count;
    }
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceRemovePctCountGroup(metricParams) {
  return function(p,v) {
    if(!checkNullRemove(p,v,metricParams)) {
      if(checkFilters(metricParams.filter,v)) {
        p.sum -= 1;
      }
      --p.count;
      if(p.count == 0) {
        p.value = 0;
      }
      else {
        p.value = p.sum/p.count;
      }
    }
    setNullValue(p,v,metricParams);
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceInitPctCountGroup() {
  return {count:0, withNullCount: 0, sum:0, value:0, empty: true};
}

export function crossfilterReduceAddPctSumColumn(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullAdd(p,v,metricParams)) {
      p.sumColumn += runFormatFunctions(metricParams.formatFunction,v[metricParams.reduceFunction.column]);
      p.sum += runFormatFunctions(metricParams.formatFunction,v[metricParams.metric]);
      if(p.sumColumn==0) {
        p.value = 0;
      }
      else {
        p.value = p.sum/p.sumColumn;
      }
      ++p.count; 
    }    
    fixFloatingPointProblem(p);   
    return p;
  };
}

export function crossfilterReduceRemovePctSumColumn(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullRemove(p,v,metricParams)) {
      p.sumColumn -= runFormatFunctions(metricParams.formatFunction,v[metricParams.reduceFunction.column]);
      p.sum -= runFormatFunctions(metricParams.formatFunction,v[metricParams.metric]);
      if(p.sumColumn == 0) {
        p.value = 0;
      }
      else {
        p.value = p.sum/p.sumColumn; 
      } 
      --p.count;   
    }    
    setNullValue(p,v,metricParams);
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceInitPctSumColumn() {
  return {count:0, withNullCount: 0, sumColumn:0, sum:0, value:0, empty: true};
}

export function crossfilterReduceAddPondAvg(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullAdd(p,v,metricParams)) {
      var column = runFormatFunctions(metricParams.formatFunction,v[metricParams.reduceFunction.column]);
      p.sumColumn += column;
      p.sum += runFormatFunctions(metricParams.formatFunction,v[metricParams.metric])*column;
      p.value = p.sum/p.sumColumn; 
      ++p.count; 
    }       
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceRemovePondAvg(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullRemove(p,v,metricParams)) {
      var column = runFormatFunctions(metricParams.formatFunction,v[metricParams.reduceFunction.column]);
      p.sumColumn -= column;
      p.sum -= runFormatFunctions(metricParams.formatFunction,v[metricParams.metric])*column;
      if(p.sumColumn == 0) {
        p.sum = 0;
        p.value = 0;
      }
      else {
        p.value = p.sum/p.sumColumn; 
      } 
      --p.count;   
    }    
    setNullValue(p,v,metricParams);
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceInitPondAvg() {
  return {count:0, withNullCount: 0, sumColumn:0, sum:0, value:0, empty: true};
}

export function crossfilterReduceAddCountIfPongAvg(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullAdd(p,v,metricParams)) {
      if((v[metricParams.reduceFunction.column_group] in p.columnLookUp)==false) {
        p.columnLookUp[v[metricParams.reduceFunction.column_group]]={count:0,sumColumn:0,sum:0,value:0};
      }
      var lookupObject = p.columnLookUp[v[metricParams.reduceFunction.column_group]];
      var column = runFormatFunctions(metricParams.formatFunction,v[metricParams.reduceFunction.column]);
      var lastValue = lookupObject.value;      
      lookupObject.sumColumn += column;
      lookupObject.sum += runFormatFunctions(metricParams.formatFunction,v[metricParams.metric])*column;
      lookupObject.value = lookupObject.sum/lookupObject.sumColumn;
      var lastValueInRange = isInRange(metricParams.reduceFunction.filters, lastValue, [], []);
      var actualValueInRange = isInRange(metricParams.reduceFunction.filters, lookupObject.value, [], []);
      if(actualValueInRange == true && (lastValueInRange == false || lookupObject.count==0)) {
        ++p.count;
        ++p.value;
      }
      else if(actualValueInRange == false && (lastValueInRange == true && lookupObject.count>0)) {
        --p.count;
        --p.value;        
      }
      ++lookupObject.count;

    }       
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceRemoveCountIfPongAvg(metricParams) {
  return function(p,v) {
    if(checkFilters(metricParams.filter,v) && !checkNullRemove(p,v,metricParams)) {
      var column = runFormatFunctions(metricParams.formatFunction,v[metricParams.reduceFunction.column]);
      var lookupObject = p.columnLookUp[v[metricParams.reduceFunction.column_group]];
      var lastValue = lookupObject.value;
      --lookupObject.count;
      lookupObject.sumColumn -= column;
      lookupObject.sum -= runFormatFunctions(metricParams.formatFunction,v[metricParams.metric])*column;
      if(lookupObject.sumColumn == 0) {
        lookupObject.sum = 0;
        lookupObject.value = 0;
      }
      else {
        lookupObject.value = lookupObject.sum/lookupObject.sumColumn;
      }
      var lastValueInRange = isInRange(metricParams.reduceFunction.filters, lastValue, [], []);
      var actualValueInRange = isInRange(metricParams.reduceFunction.filters, lookupObject.value, [], []);
      if((actualValueInRange == true && lookupObject.count>0) && lastValueInRange == false) {
        ++p.count;
        ++p.value;
      }
      else if((actualValueInRange == false || lookupObject.count==0) && lastValueInRange == true) {
        --p.count; 
        --p.value;
      }
    }    
    setNullValue(p,v,metricParams);
    fixFloatingPointProblem(p);
    return p;
  };
}

export function crossfilterReduceInitCountIfPongAvg() {
  return {count:0, withNullCount: 0, value: 0, empty: true, columnLookUp:{}};
}

export function remove_bins(source_group,bins) {
    return {
        all:function () {
            return source_group.all().filter(function(d) {
                return bins.indexOf(d.key) === -1;
            });
        },
        top: function(n) {
            return source_group.top(Infinity)
                .filter(function(d) {
                    return bins.indexOf(d.key) === -1;
                })
                .slice(0, n);
        }
    };
}

export function ensure_group_bins(source_group,ensureValue,bins) { // (source_group, bins...}    
    return {
        all:function () {
            var original = source_group.all().slice(0); // copy original results (we mustn't modify them)
            var result = [];
            var found = {};
            
            for(var i=0;i<original.length;i++) {
              var d = original[i];
              found[d.key] = d;
            }                                  
            for(var i=0;i<bins.length;i++) {
              var d = bins[i];
              if(d in found) {
                  result[i] = found[d];
              }
              else {
                result[i] = {key: d, value: {value: ensureValue, empty: false}};
              }
            }
            return result;
        },
        top: function(n) {
            var original = source_group.all().slice(0); // copy original results (we mustn't modify them)
            var result = [];
            var found = {};
            
            for(var i=0;i<original.length;i++) {
              var d = original[i];
              found[d.key] = d;
            }                                  
            for(var i=0;i<bins.length;i++) {
              var d = bins[i];
              if(d in found) {
                  result[i] = found[d];
              }
              else {
                result[i] = {key: d, value: {value: ensureValue, empty: false}};
              }
            }
            return result.slice(0,n);
        }
    };
};

export function rank_group(source_group,_order) { 
    return {
        all:function () {
            var order = -1;
            if(_order == "ASC") {
              order = 1;
            }
            var original = source_group.top(Infinity); // copy original results (we mustn't modify them)
            var sortByFoo = crossfilter.quicksort.by(function(d) { return order*d.value.value; })
            original = sortByFoo(original,0,original.length);
            var result = [];
            var rank = 1;
            for(var i=0;i<original.length;i++) {
              if(original[i].value.value != null) {
                result[i] = {key: original[i].key, value: {value: rank, empty: false}}
                rank = rank + 1;
              }
              else {
                result[i] = {key: original[i].key, value: {value: null, empty: false}}
              }
            }                                  
            return result;
        },
        top: function(n) {
            var order = -1;
            if(_order == "ASC") {
              order = 1;
            }
            var original = source_group.top(Infinity).slice(0, n); // copy original results (we mustn't modify them)
            var sortByFoo = crossfilter.quicksort.by(function(d) { return order*d.value.value; })
            original = sortByFoo(original,0,original.length);
            var result = [];
            var rank = 1;
            for(var i=0;i<original.length;i++) {
              if(original[i].value.value != null) {
                result[i] = {key: original[i].key, value: {value: rank, empty: false}}
                rank = rank + 1;
              }
              else {
                result[i] = {key: original[i].key, value: {value: null, empty: false}}
              }
            }                                  
            return result;
        },
        bottom: function(n) {
            var order = -1;
            if(_order == "ASC") {
              order = 1;
            }
            var original = source_group.top(Infinity).slice(0, n); // copy original results (we mustn't modify them)
            var sortByFoo = crossfilter.quicksort.by(function(d) { return order*d.value.value; })
            original = sortByFoo(original,0,original.length);
            var result = [];
            var rank = 1;
            for(var i=0;i<original.length;i++) {
              if(original[i].value.value != null) {
                result[i] = {key: original[i].key, value: {value: rank, empty: false}}
                rank = rank + 1;
              }
              else {
                result[i] = {key: original[i].key, value: {value: null, empty: false}}
              }
            }                                  
            return result;
        }
    };
};

export function remove_empty_bins(source_group) {
    return {
        all:function () {
            return source_group.all().filter(function(d) {
                if((typeof d.value === "object") && ("count" in d.value)) {
                  return !d.value.empty;
                }
            });
        },
        top: function(n) {
            return source_group.top(Infinity)
                .filter(function(d) {
                    if((typeof d.value === "object") && ("count" in d.value)) {
                      return !d.value.empty;
                    }
                })
                .slice(0, n);
        }
    };
}

export function merge_groups(source_groups) { // (source_group, bins...}
    function getNValues(n) {
        var result = [];
        var found = {};
        
        for(var i=0;i<source_groups.length;i++) {
          var iterateTo;
          if(n == null) {
            iterateTo = source_groups[i].all().length;
          }
          else {
            iterateTo = Math.min(n,source_groups[i].all().length);
          }
          for(var j=0;j<iterateTo;j++) {
            var d = source_groups[i].all()[j];

            if(!(d.key in found)) {
              found[d.key] = {};  
            }
            found[d.key][i] = d.value;
          }              
        }        
        var i = 0;
        for (var groupKey in found) {
          result[i] = {key: groupKey, values: found[groupKey]}
          ++i;
        }                          
        return result;
    };
    return {
        all:function () {
            return getNValues(null);
        },
        top: function (n) {
            return getNValues(n);
        },
        bottom: function (n) {
            return getNValues(n);
        },
    };
};

export function empty_group() {
    return {
        all: function () {
            return [];
        },
        top: function (n) {
            return [];
        }
    };
};





// WEBPACK FOOTER //
// ./source/client/components/common/graphs/crossfilterGraphs/util/chartsUtilFunctions.js